import { NgModule } from '@angular/core';
import { StationsService } from './stations.service';
import { StationsBackend } from './stations.backend';

@NgModule({
  providers: [StationsService, StationsBackend],
})
export class StationsModule {}
